var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCentipedeEnergySegment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 206.8 186.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203,79l-37.3-64.6C160.5,5.5,151,0,140.7,0h-6.6h-68C55.8,0,46.3,5.5,41.2,14.4L3.8,79c-5.1,8.9-5.1,19.9,0,28.8 l37.3,64.6c5.1,8.9,14.7,14.4,24.9,14.4h68h6.6c10.3,0,19.8-5.5,24.9-14.4l37.3-64.6C208.1,98.9,208.1,87.9,203,79z M131.3,91.2 l-28.5,46.7c-3.3,5.5-11.7,2.9-11.3-3.5l1.7-28c0.1-0.9-0.6-1.6-1.5-1.6h-11c-4.8,0-7.7-5.2-5.2-9.3L104,48.9 c3.3-5.5,11.7-2.9,11.3,3.5l-1.7,28c-0.1,0.9,0.6,1.6,1.5,1.6h11C130.9,82,133.8,87.2,131.3,91.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentipedeEnergySegment);
export default __webpack_public_path__ + "static/media/centipede-energy-segment.db1b77817303880f2b7ac2c9cca9de5f.svg";
export { ForwardRef as ReactComponent };